import { HelpOutlined as HelpOutlineIcon, WhatsApp } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { tokens } from '../../theme'

const TrainingsButton = ({
  page,
  hasCorral,
  data = {
    color: tokens.brand.orange,
    title: 'Página de treinamentos',
    link: '',
    isWhatsApp: false,
  },
}) => {
  const navigate = useNavigate()

  const handleOpenBlankLink = () => {
    window.open(data?.link, '_blank')
  }

  const handleButtonClick = () => {
    navigate('/treinamentos', { state: { page, hasCorral } })
  }

  const buttonStyle = {
    backgroundColor: data.color,
    borderRadius: '50%',
    position: 'fixed',
    bottom: '20px',
    left: '100px',
    zIndex: 1000,
  }

  return (
    <Tooltip title={data.title} arrow>
      {data.isWhatsApp ? (
        <IconButton
          onClick={data.link !== '' ? handleOpenBlankLink : handleButtonClick}
          style={buttonStyle}
          size='large'
        >
          <WhatsApp
            style={{ height: '1.5rem', width: '1.5rem', color: '#fff' }}
          />
        </IconButton>
      ) : (
        <IconButton
          onClick={
            !!data && data.link ? handleOpenBlankLink : handleButtonClick
          }
          style={buttonStyle}
          size='large'
        >
          <HelpOutlineIcon
            style={{ height: '1.5rem', width: '1.5rem', color: '#fff' }}
          />
        </IconButton>
      )}
    </Tooltip>
  )
}

export default TrainingsButton
